
var campaignPageApp = function() {
    var init = function() {
        if( document.body.classList.contains('single-campaign') ) {
            updateCountDownTimer()
            replaceDonationButtonLocations()
        }
    }      

    /* FUNCTIONS */
    function replaceDonationButtonLocations() {
        const anchorLocation = '#donation-form-section';

        //Desktop nav button
        const desktopNavListElement = document.querySelector('#desktop-nav .main-nav-right').lastElementChild
        const desktopNavButton = desktopNavListElement.lastElementChild
        desktopNavButton.href = anchorLocation;

        //Mobile nav button
        const mobileNavListButton = document.querySelector('.mobile-header .container').lastElementChild
        mobileNavListButton.href = anchorLocation;

        //Smooth scrolling for all anchor links
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                let hashval = this.getAttribute('href')
                let target = document.querySelector(hashval)
                const yOffset = -105;
                const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
           
                history.pushState(null, null, hashval)
                e.preventDefault();
            });
        });
    }

    function makeCountdownTimer() {
        var timer = setInterval( function(){ updateCountDownTimer( timer ); }, 1000 );
        return timer;
    }

    function updateCountDownTimer( timer ) {

        let endTime = document.getElementById('countdown');

        if( endTime ) {

            endTime = endTime.getAttribute('data-time');

            var nowTime = new Date();
            var nowDifference = -1 * ( nowTime.getTimezoneOffset() * 60 );

            nowTime = ( Date.parse( nowTime ) / 1000 );

            var timeLeft = endTime - nowTime - nowDifference;

            var days = Math.floor( timeLeft / 86400 ); 
            var hours = Math.floor( ( timeLeft - ( days * 86400 ) ) / 3600 );
            var minutes = Math.floor( ( timeLeft - ( days * 86400 ) - ( hours * 3600 ) ) / 60 );

            if ( days < '10' ) { days = '0' + days; }
            if ( hours < '10' ) { hours = '0' + hours; }
            if ( minutes < '10' ) { minutes = '0' + minutes; }

            var daysOutput = days.toString().split('');
            var hoursOutput = hours.toString().split('');
            var minutesOutput = minutes.toString().split('');

            document.getElementById( 'timer' ).innerHTML = 
            '<div class="digits"><div><span class="digit-box">' + daysOutput[0] + '</span><span class="days digit-box">' + daysOutput[1] + '</span></div><div class="digit-text">Päivää</div></div>' + 
            '<span class="split">:</span>' +
            '<div class="digits"><div><span class="digit-box">' + hoursOutput[0] + '</span><span class="hours digit-box">' + hoursOutput[1] + '</span></div><div class="digit-text">Tuntia</div></div>' + 
            '<span class="split">:</span>' +
            '<div class="digits"><div><span class="digit-box">' + minutesOutput[0] + '</span><span class="minutes digit-box">' + minutesOutput[1] + '</span></div><div class="digit-text">Minuuttia</div></div>'; 

            if( timeLeft <= 0 ) {

                document.getElementById( 'timer' ).innerHTML = 
                '<span class="digit-box">0</span><span class="days digit-box">0</span>' + 
                '<span class="digit-box">0</span><span class="hours digit-box">0</span>' + 
                '<span class="digit-box">0</span><span class="minutes digit-box">0</span>';

                clearInterval( timer );
            }
        }
    }

    return { init: init }
}();


document.addEventListener("DOMContentLoaded", function(){
    campaignPageApp.init();
});



